export default __webpack_public_path__ + "static/media/card-logo.eb11541f.webp";